import { Component, AfterViewInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from '../../http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-agent-management',
  templateUrl: './agent-management.component.html',
  styleUrls: ['./agent-management.component.scss']
})
export class AgentManagementComponent implements AfterViewInit, OnDestroy {

  public company_uuid;
  public selectedAgent: any = null;
  public attendance: any[] = [];
  public attendanceLoading = false;
  public attendanceError = '';
  public attendanceFilter = { date_from: '', date_to: '' };
  private statusRefreshTimer: ReturnType<typeof setInterval> | null = null;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

   ngAfterViewInit(): void {
    // Use the same MYT calendar dates as the attendance ledger, regardless of
    // the manager's browser timezone.
    const today = new Date(Date.now() + 8 * 60 * 60 * 1000);
    const from = new Date(today);
    from.setUTCDate(from.getUTCDate() - 29);
    this.attendanceFilter = {
      date_from: this.toDateInput(from),
      date_to: this.toDateInput(today),
    };
    this.init();
    this.statusRefreshTimer = setInterval(() => {
      if (!this.selectedAgent) {
        void this.tb?.reload();
      }
    }, 60_000);
  }

  ngOnDestroy(): void {
    if (this.statusRefreshTimer) {
      clearInterval(this.statusRefreshTimer);
      this.statusRefreshTimer = null;
    }
  }

  private toDateInput(date: Date): string {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  async init() {
    const setting = 
        { post: {url: "/admin/agent/list", data: {uuid: this.company_uuid}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Code', type: 'string', key: 'code'}, 
            {label: 'Name', type: 'string', key: 'name'}, 
            {label: 'Mobile', type: 'string', key: 'mobile'}, 
            {label: 'Is Agent', type: 'status', key: 'is_agent'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'Last Online', type: 'last-online', key: 'last_active_at', fallbackKey: 'offline_since'},
            {label: 'Work Status', type: 'work-status', key: 'is_online', visible: (row) => Number(row.is_agent) === 1},
            {label: 'Offline Alert', type: 'alert-status', key: 'is_offline_overdue', visible: (row) => Number(row.is_agent) === 1},
            {label: 'Attendance', type: 'button', action: (row) => this.showAttendance(row), visible: (row) => Number(row.is_agent) === 1},
            {label: 'Direct Agents', type: 'string', key: 'total_agent'},
            {label: 'Referral Downline', type: 'string', key: 'total_player'},
            {label: 'Rolling Game Rate', type: 'link', blockWhenSuspended: true, key: 'uuid', 'link': '/lo' + (this.company_uuid ? '/' + this.company_uuid : '/null') + "/agent/rate/"},
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }

  async showAttendance(agent: any) {
    this.selectedAgent = agent;
    await this.loadAttendance();
  }

  async loadAttendance() {
    if (!this.selectedAgent) return;
    this.attendanceLoading = true;
    this.attendanceError = '';
    const result: any = await this.http.post('/admin/agent/attendance/list', {
      company_uuid: this.company_uuid,
      agent_uuid: this.selectedAgent.uuid,
      ...this.attendanceFilter,
    });
    this.attendanceLoading = false;
    if (!result || !result.status) {
      this.attendance = [];
      this.attendanceError = result?.message || 'Unable to load attendance history.';
      return;
    }
    this.attendance = result.collection || [];
  }

  closeAttendance() {
    this.selectedAgent = null;
    this.attendance = [];
    this.attendanceError = '';
  }
}
